import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router";
import api from "../../services/api";
import { langoptions, minimumSpendOptions, osOptions, genderOptions, roles, removeCommonLocation, updateBlockerFlag, w2n_android_versions, w2n_ios_versions } from '../../utils/constants';
import { daysBetween, NEWISODateString, SameDay, formatDateWithTime, DatetoTimestamp, End_date_cpd } from "../../utils/dateFormat";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Stepper from 'react-stepper-horizontal';
import { SlButton } from '@shoelace-style/shoelace/dist/react';

export const campCreativeContext2 = React.createContext();

var appCategoryOptions = [
    { value: "0", label: "All", isdisabled: false },
    { value: '3', label: 'Sports', isdisabled: false },
    { value: '1', label: 'News', isdisabled: false },
    { value: '2', label: 'Business', isdisabled: false },
    { value: '4', label: 'Cinema', isdisabled: false },
    { value: '5', label: 'Special', isdisabled: false },
    { value: '6', label: 'Politics', isdisabled: false }
]
const langoptions_preview = ["", "Telugu", "Tamil", "Hindi", "Kannada", "Malayalam", "Marathi", "Bengali", "Gujarati", "Punjabi", "Odia", "English", "", "Telugu-English"]
const appCategoryOptions_preview = ["All", "News", "Business", "Sports", "Cinema", "Special", "Politics"]
const genderOptions_preivew = ["All", "Male", "Female"]
const osOptions_preview = ["All", "Android", "IOS"]




let languageOptions = []

function Target() {

    const steps = [
        { title: 'LineItem' },
        { title: 'Targets' },
        { title: 'Dates & Budget' },
        { title: 'Creative Selection' },

    ];
    const [appCategoryOptions, setappCategoryOptions] = useState([
        // { value: "0", label: "All", isdisabled: false },
        { value: '1', label: 'News', isdisabled: true },
        { value: '2', label: 'Business', isdisabled: true },
        { value: '3', label: 'Sports', isdisabled: true },
        { value: '4', label: 'Cinema', isdisabled: true },
        { value: '5', label: 'Special', isdisabled: true },
        { value: '6', label: 'Politics', isdisabled: true }
    ])
    const [actual_target, setactual_target] = useState({})
    const [selectedlocs, setSelectedlocs] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const [zoneOptions, setZoneOptions] = useState([])
    const [stateOptions, setStateOptions] = useState([])
    const [districtOptions, setDistrictOptions] = useState([])
    const [mandalOptions, setMandalOptions] = useState([])
    const [villageOptions, setVillageOptions] = useState([])
    const [constituencyOptions, setConstituencyOptions] = useState([])
    const [disableNext, setDisableNext] = useState(false)
    let type = ""
    let typeofcamp = ""
    // const typedef = () => {
    //     if ((location.state.start.campaign_type === "CPC" || location.state.start.campaign_type === "CPM") && (location.state.dfp)) {
    //         return "DFP"
    //     }
    //     if ((location.state.start.campaign_type === "CPC" || location.state.start.campaign_type === "CPM") && !(location.state.dfp)) {
    //         return "Editorial"
    //     }
    //     else {
    //         return "Local"
    //     }
    // }
    if (location.state){
        type = location.state.type
        typeofcamp = location.state.start.campaign_type
    }
    const isBrandAd = location.state.isBrandAd
    if (typeofcamp === "CPD" && type !== 'DFP') {
        let arr = langoptions.filter((lang) => {
            if (lang.value === 1 || lang.value === 2 || lang.value === 10) return true
            else return false
        })
        languageOptions = arr
    }
    else {
        languageOptions = langoptions
    }

    const order = location.state.order


    const setfield = async (array, field, temp, lang_ids) => {
        let arr = []
        if (Array.isArray(array) && field !== "state_ids" && field !== "district_ids" && field !== "mandal_ids" && field !== "village_ids" && field !== "constituency_ids")
            array?.map((x) => arr.push({ value: x, label: x }))

        switch (field) {

            case "lang_ids":
                await lang_idsOnchange(arr)
                await onchange(arr, "lang_ids");
                break
            case "os":
                onchange(arr, "os");
                break
            case "app":
                apponchange(arr);
                break
            case "minspend":
                onchange(arr, "minspend");
                break
            case "zone_ids":
                let zones = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.zone_name}` }
                    zones.push(temp)
                }
                onchange(zones, "zone_ids");
                break
            case "state_ids":

                let states = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.state_name}` }
                    states.push(temp)
                }
                await state_idsOnchange(states, lang_ids)
                onchange(states, "state_ids")
                break
            case "district_ids":
                let districts = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.dist_name}` }
                    districts.push(temp)
                }
                await district_idsOnchange(districts, lang_ids)
                onchange(districts, "district_ids")
                break
            case "mandal_ids":
                let mandals = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.mandal_name}` }
                    mandals.push(temp)
                }
                let tempDistricts = []
                for await (let item of temp) {
                    tempDistricts.push(item.dist_id)
                }
                await mandal_idsOnchange(mandals, tempDistricts, lang_ids, false)
                onchange(mandals, "mandal_ids")
                break
            case "village_ids":
                let villages = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.village}` }
                    villages.push(temp)
                }
                onchange(villages, "village_ids")
                break
            case 'constituency_ids':
                let constituents = []
                for await (let item of array) {
                    const temp = {value: item, label: `${item.const_name}`}
                    constituents.push(temp)
                }
                onchange(constituents, 'constituency_ids')
            default:

        }
    }
    const editaction = async () => {
        setDisableNext(true)
        const target = location.state.target
        await setfield(target.lang_ids, "lang_ids", [])
        await formik.setFieldValue("os", target.os)
        await formik.setFieldValue("gender", target.gender)
        await formik.setFieldValue("min_age", target.min_age)
        await formik.setFieldValue("max_age", target.max_age)
        await formik.setFieldValue("exclude", target.exclude)
        await formik.setFieldValue("android_version", target.android_version || "")
        await formik.setFieldValue("ios_version", target.ios_version || "")

        await setfield(target.app, "app", [])
        await setfield(target.minspend, "minspend", [])
        await setfield(target.zone_ids || [], "zone_ids", [], target.lang_ids)
        await setfield(target.state_ids, "state_ids", [], target.lang_ids)
        await setfield(target.district_ids, "district_ids", [], target.lang_ids)
        await setfield(target.mandal_ids, "mandal_ids", target.district_ids, target.lang_ids)
        await setfield(target.village_ids, "village_ids", [], target.lang_ids)
        await setfield(target.constituency_ids, "constituency_ids", [], target.lang_ids)
        setDisableNext(false)
    }
    const prefilling = async () => {
        let target = location.state.prefillingData.target
        let exactLangIds = languageOptions.map(item => item.value)
        target.lang_ids = target.lang_ids.filter(item => exactLangIds.includes(item))
        await setfield(target.lang_ids?.filter(item => exactLangIds.includes(item)), "lang_ids", [])
        await setfield(target.state_ids?.filter(item => exactLangIds.includes(item.lang_id)), "state_ids", [], target.lang_ids)
        await setfield(target.district_ids?.filter(item => exactLangIds.includes(item.lang_id)), "district_ids", [], target.lang_ids)
        await setfield(target.mandal_ids?.filter(item => exactLangIds.includes(item.lang_id)), "mandal_ids", target.district_ids, target.lang_ids)
        await setfield(target.constituency_ids?.filter(item => exactLangIds.includes(item.lang_id)), "constituency_ids", [])
    }

    const getvalues = (Array, field) => {
        if (Array.length > 0) {
            switch (field) {
                case "lang_ids":
                    return Array.filter((option) => formik.values.lang_ids.indexOf(option.value) >= 0)
                case "os":
                    return Array.filter((option) => formik.values.os.indexOf(option.value) >= 0)
                case "app":
                    return Array.filter((option) => formik.values.app.indexOf(option.value) >= 0)
                case "minspend":
                    return Array.filter((option) => formik.values.minspend.indexOf(option.value) >= 0)
                case "state_ids":
                    let fun = []
                    formik.values.state_ids.map((option) => { fun.push(option.state_id); return null; })
                    return Array.filter((option) => fun.indexOf(option.value.state_id) >= 0)
                case "district_ids":
                    const res1 = []
                    formik.values.district_ids.map((option) => { res1.push(option.dist_id); return null; })
                    return Array.filter((option) => res1.indexOf(option.value.dist_id) >= 0)

                case "mandal_ids":
                    const res2 = []
                    formik.values.mandal_ids.map((option) => { res2.push(option.mandal_id); return null; })
                    return Array.filter((option) => res2.indexOf(option.value.mandal_id) >= 0)
                case "village_ids":
                    const res3 = []
                    formik.values.village_ids.map((option) => { res3.push(option.village_id); return null; })
                    return Array.filter((option) => res3.indexOf(option.value.village_id) >= 0)
                case "constituency_ids":
                    const res4 = []
                    formik.values.constituency_ids.map((option) => { res4.push(option.const_id); return null;})
                    return Array.filter((option) => res4.indexOf(option.value.const_id) >= 0)
                case "zone_ids":
                    const res5 = []
                    formik.values.zone_ids.map((option) => { res5.push(option.zone_id); return null;})
                    return Array.filter((option) => res5.indexOf(option.value.zone_id) >= 0)
                // case "pincodes":
                // return Array.filter((option) => formik.values.pincodes.indexOf(option.value) >= 0)

                default:
                    return []

            }
        } else {
            return [];
        }
    }

    const defaultValue = (options, value) => {
        return options ? options.find((option) => option.value === value) : "";
    };

    const formik = useFormik({
        initialValues: {
            lang_ids: [],
            zone_ids: [],
            state_ids: [],
            district_ids: [],
            mandal_ids: [],
            village_ids: [],
            pincodes: [],
            os: '0',
            app: ["1"],
            minspend: [],
            min_age: '',
            max_age: '',
            gender: 0,
            exclude: 0,
            constituency_ids: [],
            ios_version: "",
            android_version: ""
        },
        validationSchema: Yup.object({
            lang_ids: Yup.array().required("Language is required").min(1, "Please select atleast one language"),
            zone_ids: Yup.array(),
            state_ids: Yup.array(),
            district_ids: Yup.array(),
            mandal_ids: Yup.array(),
            village_ids: Yup.array(),
            pincodes: Yup.array(),
            os: Yup.string(),
            app: Yup.array(),
            minspend: Yup.array(),
            gender: Yup.number(),
            min_age: Yup.number().min(18, "Minimum 18 required").max(80, "Should be below 80"),
            max_age: Yup.number().min(Yup.ref("min_age"), 'Should be greater than min age').max(80, "Should be below 80"),
            exclude: Yup.number(),
            constituency_ids: Yup.array()
        }),
        onSubmit: async (values) => {
            if (location?.state?.target?.target_id) {
                values.target_id = location?.state?.target?.target_id;
            }
            if (location?.state?.type === 'DFP') {
                values.mandal_ids = []
                values.state_ids = []
                values.zone_ids = []
                values.village_ids = []
                values.minspend = []
                values.district_ids = []
                values.pincodes = []
                values.constituency_ids =[]
            }
            let target_preview = await get_preview_target_data(values)
            navigate("/home/campaign/date", { state: { ...location.state, target: { ...values, locations: selectedlocs }, target_preview: target_preview } })

        }

    })
    const back = async () => {
        let result = { ...formik.values, locations: [...selectedlocs] }
        if (location?.state?.target?.target_id)
            result.target_id = location?.state?.target?.target_id
        let target_preview = await get_preview_target_data(formik.values)
        navigate("/home/campaign/start",
            { state: { ...location.state, target: result, target_preview: target_preview } }
        )
    }
    useEffect(() => {
        if (localStorage.getItem("role") !== roles.ops)
            navigate("/pagenotfound")
        if (location?.state?.target) {
            editaction()
            const temp = location.state.target.locations
            setTimeout(() => setSelectedlocs(temp), 0)
        }
        else if(location?.state?.prefillingData?.target){
            prefilling()
        }
    }, [])
    // const removeCommonLocation = (lang_ids, state_ids, district_ids, mandal_ids, village_ids, exclude) => {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             let mandalRes = [], districtRes = [], statesRes = [], villageRes = [], mandaldum = [], districtdum = [], statedum = [], langdum = [];
    //             let ex_villages = [], ex_mandals = [], ex_districts = [], states = [], mandalsinlist = [], districtinlist = [], statesinlist = [], villagesinlist = [];
    //             if (mandal_ids.length) mandalsinlist = mandal_ids.map(j => +j.mandal_id);
    //             if (district_ids.length) districtinlist = district_ids.map(j => +j.dist_id);
    //             if (state_ids.length) statesinlist = state_ids.map(j => +j.state_id);
    //             if (village_ids.length) villagesinlist = village_ids.map(j => +j.village_id)
    //             if (village_ids.length) mandaldum = village_ids.map(j => +j.mandal_id)
    //             if (mandal_ids.length) districtdum = mandal_ids.map(j => +j.dist_id)
    //             if (district_ids) statedum = district_ids.map(j => +j.state_id)
    //             if (state_ids) langdum = state_ids.map(j => +j.lang_id)
    //             // console.log(villageRes, "{{{{{{{{{{{{{{{{{{{{", village_ids.map(j => +j.village_id), lang_ids, state_ids, district_ids, mandal_ids, village_ids, "++++++++++++++")
    //             if (exclude) {
    //                 if (village_ids.length) {
    //                     ex_villages = villagesinlist
    //                     mandalRes = mandaldum
    //                     villageRes = []
    //                 }
    //                 if (mandal_ids.length) {
    //                     ex_mandals = mandalsinlist.filter(item => !mandaldum.includes(item))
    //                     districtRes = []
    //                     mandal_ids.map((item) => { if (ex_mandals.includes(item.mandal_id)) districtRes.push(+item.dist_id) })
    //                 }
    //                 if (district_ids.length) {
    //                     ex_districts = districtinlist.filter(item => !districtdum.includes(+item))
    //                     statesRes = []
    //                     district_ids.map((item) => { if (ex_districts.includes(+item.dist_id)) statesRes.push(+item.state_id) })
    //                     let tempStates = statesinlist.filter(item => !statedum.includes(item))
    //                     statesRes = [...new Set([...statesRes,...tempStates])]
    //                 }
    //                 // statesRes = statesinlist
    //             }
    //             else {
    //                 villageRes = villagesinlist
    //                 statesRes = statesinlist.filter(item => !statedum.includes(item))
    //                 mandalRes = mandalsinlist.filter(item => !mandaldum.includes(item))
    //                 districtRes = districtinlist.filter(item => !districtdum.includes(item))
    //             }
    //             lang_ids = lang_ids.filter(item => !langdum.includes(item))

    //             statesRes = Array.from(new Set(statesRes))
    //             districtRes = Array.from(new Set(districtRes))
    //             mandalRes = Array.from(new Set(mandalRes))
    //             villageRes = Array.from(new Set(villageRes))
    //             ex_districts = Array.from(new Set(ex_districts))
    //             ex_mandals = Array.from(new Set(ex_mandals))
    //             ex_villages = Array.from(new Set(ex_villages))
    //             // if (village_ids.length)
    //             //   villages = village_ids.filter(item => !mandalRes.includes(+item.mandal_id)).map(item => +item.village_id);
    //             // if (mandal_ids.length)
    //             //   mandals = mandal_ids.filter(item => !districtRes.includes(+item.dist_id)).map(item => +item.mandal_id);
    //             // if (district_ids.length)
    //             //   districts = district_ids.filter(item => !statesRes.includes(+item.state_id)).map(item => +item.dist_id);
    //             // if (state_ids.length)
    //             //   states = state_ids.filter(item => {
    //             //     if (lang_ids.includes(+item.lang_id)) {
    //             //       let index = lang_ids.findIndex(j => j === +item.lang_id);
    //             //       lang_ids.splice(index, 1)
    //             //       return true
    //             //     }
    //             //     return false
    //             //   }).map(j => +j.state_id);
    //             return resolve({ lang_ids, state_ids: statesRes, district_ids: districtRes, mandal_ids: mandalRes, village_ids: villageRes, ex_villages, ex_mandals, ex_districts })
    //         } catch (error) {
    //             console.error(error);
    //         }
    //     })
    // }
    const get_preview_target_data = (values) => {

        let lang_ids = values.lang_ids.filter((item, i) => actual_target.lang_ids.includes(item)
        ).map(item => langoptions_preview[item])
        let state_ids = values.state_ids.filter((item, i) => actual_target.state_ids.includes(item.state_id)
        ).map(item => item.state_name)
        let district_ids = values.district_ids.filter((item, i) => actual_target.district_ids.includes(item.dist_id)
        ).map(item => `${item.dist_name}(D), ${item.state_name}(S)`)
        let mandal_ids = values.mandal_ids.filter((item, i) => actual_target.mandal_ids.includes(item.mandal_id)
        ).map(item => `${item.mandal_name}(M), ${item.district_name}(D)`)
        let ex_districts = values.district_ids.filter((item, i) => actual_target.ex_districts.includes(item.dist_id)
        ).map(item => `${item.dist_name}(D), ${item.state_name}(S)`)
        let ex_mandals = values.mandal_ids.filter((item, i) => actual_target.ex_mandals.includes(item.mandal_id)
        ).map(item => `${item.mandal_name}(M), ${item.district_name}(D)`)
        let village_ids = formik.values.village_ids.filter((item, i) => actual_target.village_ids.includes(item.village_id)
        ).map(item => `${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`)
        let ex_villages = formik.values.village_ids.filter((item, i) => actual_target.ex_villages.includes(item.village_id)
        ).map(item => `${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`)
        let constituencies = formik.values.constituency_ids.map(item => `${item.const_name}(C), ${item.district_name}(D)`)
        let zone_ids = values.zone_ids?.length ? values.zone_ids?.map(item => item.zone_name) : []
        let app = values.app.map((item, i) => {

            return `${appCategoryOptions_preview[item]}`
        })
        let minspend = values.minspend
        let min_age = values.min_age
        let max_age = values.max_age
        let os = osOptions_preview[values.os]
        let gender = genderOptions_preivew[values.gender]
        return { lang_ids, state_ids, district_ids, mandal_ids, zone_ids, ex_districts, ex_mandals, village_ids, ex_villages, app, minspend, min_age, max_age, os, gender, exclude: values.exclude, constituencies, android_version: values.android_version, ios_version: values.ios_version }
    }
    const actual_target_setting = async () => {
        setactual_target(await removeCommonLocation(formik.values.lang_ids, formik.values.state_ids, formik.values.district_ids, formik.values.mandal_ids, formik.values.village_ids, formik.values.exclude))
    }

    useEffect(() => {
        actual_target_setting()

    }, [formik.values])

    const onchange = (selected, field) => {
        if (selected.length === 0)
            setSelectedlocs([])
        formik.setFieldValue(field, selected ? (selected).map((item) => item.value) : []);

    }
    const lang_idsOnchange = async (selected) => {
        const langs = selected ? (selected).map((item) => item.value) : []
        try {
            let res = await api({
                url: '/location/getStatesByLangId',
                method: 'POST',
                responseType: 'json',
                data: langs
            })
            let states = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.state_name}` }
                states.push(temp)
            }
            setStateOptions(states)
            let zones = await api({
                url: '/location/getZonesByLangId',
                method: 'POST',
                responseType: 'json',
                data: langs
            })
            let zonesArr = []
            for await (let item of zones.data || []) {
                const temp = { value: item, label: `${item.zone_name}` }
                zonesArr.push(temp)
            }
            setZoneOptions(zonesArr)
            formik.setFieldValue("state_ids", formik.values.state_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("zone_ids", formik.values.zone_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("district_ids", formik.values.district_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const zone_idsOnchange = () => {
        formik.setFieldValue("state_ids", [])
        formik.setFieldValue("district_ids", [])
        formik.setFieldValue("constituency_ids", [])
        formik.setFieldValue("mandal_ids", [])
        formik.setFieldValue("village_ids", [])
    }
    const state_idsOnchange = async (selected, langs) => {
        const states = selected ? (selected).map((item) => { if (item.value) return item.value.state_id }) : []
        // const langs = formik.values.lang_ids
        try {
            let res = await api({
                url: '/location/getDistrictsByStateId',
                method: 'POST',
                responseType: 'json',
                data: { states, langs }
            })
            let districts = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.dist_name}` }
                districts.push(temp)
            }
            setDistrictOptions(districts)
            let temp = []
            await formik.setFieldValue("district_ids", formik.values.district_ids.filter((option) => { if (states.indexOf(option.state_id) >= 0) { temp.push(option.dist_id); return true } }))
            formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => temp.indexOf(option.dist_id) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const district_idsOnchange = async (selected, langs) => {
        const districts = selected ? (selected).map((item) => { if (item.value) return item.value.dist_id }) : []
        try {
            let res = await api({
                url: '/location/getMandalsnew',
                method: 'POST',
                responseType: 'json',
                data: { districts, langs }
            })
            let mandals = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.mandal_name}` }
                mandals.push(temp)
            }
            setMandalOptions(mandals)
            let consties = await api({
                url: `/location/getConstituentsnew`,
                method: 'POST',
                responseType: 'json',
                data: {districts, langs}
            })
            let constituents =[]
            for await(let item of consties.data){
                const temp = { value: item, label: `${item.const_name}`}
                constituents.push(temp)
            }
            setConstituencyOptions(constituents)
            formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const mandal_idsOnchange = async (selected, districts, langs, constituency_ids) => {
        const mandals = selected ? (selected).map((item) => { if (item.value) return item.value.mandal_id }) : []
        try {
            //Remove constituency which all mandals are not selected
            if (constituency_ids) {
                const constmandals = mandalOptions.filter(item => formik.values.constituency_ids.map(item => +item.const_id).includes(item.value.const_id))
                let toRemove_consties = constmandals.filter(item => !selected.map(sitem => +sitem.value.mandal_id).includes(item.value.mandal_id)).map(item => item.value.const_id)
                formik.setFieldValue("constituency_ids", constituency_ids.filter(item => !toRemove_consties.includes(item.const_id)))
            }
            let res = await api({
                url: '/location/getVillagesnew',
                method: 'POST',
                responseType: 'json',
                data: { mandals, langs, districts }
            })
            let villages = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.village}` }
                villages.push(temp)
            }
            setVillageOptions(villages)
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => mandals.indexOf(option.mandal_id) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const constituency_idsOnchange = async (selected) => {
        if(!formik.values.lang_ids.filter(item => item === 1 || item === 2).length){
            formik.setFieldValue("mandals",[])
            formik.setFieldValue("constituency_ids", [])
            setConstituencyOptions([])
        }
        const consties = selected ? selected.map(item => {if(item.value) return +item.value.const_id}) : []
        const langs = selected ? selected.map(item => {if(item.value) return +item.value.lang_id}) : []
        const formMandals = formik.values.mandal_ids.filter(item => !formik.values.constituency_ids.map(item => +item.const_id).includes(+item.const_id)).map(item => +item.mandal_id)
        let constMandals = mandalOptions.filter(item => consties.includes(+item.value.const_id) || formMandals.includes(+item.value.mandal_id)).map(item => item.value)
        formik.setFieldValue('mandal_ids', constMandals)
        const tempMandal_ids = constMandals.map(item => +item.mandal_id)
        // await formik.setFieldValue('village_ids', formik.values.village_ids.filter(item => tempMandal_ids.includes(+item.mandal_id)))
        if(selected.length){
            await formik.setFieldValue('village_ids',[])
            formik.values.village_ids = []
        }
        mandal_idsOnchange(constMandals.map(item => {return {label: item.mandal_name, value: item}}), formik.values.district_ids.map(item => item.dist_id), formik.values.lang_ids, false)
    }
    const apponchange = (selected) => {
        var list = []
        var flag = 1
        selected.forEach(item => {
            if (item.value === "0") {
                list = []
                list.push("0")
                setappCategoryOptions([
                    // { value: "0", label: "All", isdisabled: false },
                    { value: '1', label: 'News', isdisabled: true },
                    { value: '2', label: 'Business', isdisabled: true },
                    { value: '3', label: 'Sports', isdisabled: true },
                    { value: '4', label: 'Cinema', isdisabled: true },
                    { value: '5', label: 'Special', isdisabled: true },
                    { value: '6', label: 'Politics', isdisabled: true }
                ])
                formik.setFieldValue("app", list)
                flag = 0
                return
            }
            else {

                list.push(item.value)
            }
        });
        if (flag === 1) {
            setappCategoryOptions([
                // { value: "0", label: "All", isdisabled: false },
                { value: '1', label: 'News', isdisabled: false },
                { value: '2', label: 'Business', isdisabled: false },
                { value: '3', label: 'Sports', isdisabled: false },
                { value: '4', label: 'Cinema', isdisabled: false },
                { value: '5', label: 'Special', isdisabled: false },
                { value: '6', label: 'Politics', isdisabled: false }
            ])
        }
        formik.setFieldValue("app", list)
        return
    }

    return (
        <div className='campaign-drawer'>
            <div className='title'>
                <legend>Create LineItem</legend>
               <sl-icon name="x" type="button" className="text-danger mt-2" style={{ right: 20, position: "absolute" }} onClick={() => { if(location.state.action === "edit" && (location.state?.status === 5 || location?.state?.status === 2)){updateBlockerFlag(location.state.id, false);}  navigate(`/home/order/${order.id}`, {state:{order}}) }}></sl-icon>
            </div>
            <div className='grid grid-cols-2 divide-x mt-3'>
                <div className='mobHide'>
                <section className="flex gap-6">
                        <div className="basis-7/12 grid gap-6 grid-cols-2">
                            {
                                <>
                                    {location.state.start_preview && <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                        <h6 className="mb-2">LineItem Creation</h6>
                                        {location.state.start_preview.campaign_name && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">LineItem Name : </label>
                                            <span>{location.state.start_preview.campaign_name}</span>
                                        </div>}
                                        
                                        {location.state.start_preview.campaign_type && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">LineItem Type : </label>
                                            <span>{location.state.start_preview.campaign_type}</span>
                                        </div>}
                                        {location.state.start_preview.campaign_type && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Type : </label>
                                            <span>{location.state.type}</span>
                                        </div>}
                                        {location.state.start_preview.brand && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Brand : </label>
                                            <span>{location.state.start_preview.brand_id}</span>
                                        </div>}
                                    </section>}
                                    {formik.values && <>
                                        <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                            <h6 className="mb-2">Target</h6>
                                            {actual_target.lang_ids?.length > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                                            {(Array.isArray(actual_target.lang_ids) && actual_target.lang_ids.length > 0) && formik.values.lang_ids.map((item, i) => {
                                                if (actual_target.lang_ids.includes(item))
                                                    return <span key={i}>{langoptions_preview[item]}</span>
                                            })}
                                            {(Array.isArray(formik.values.zone_ids) && formik.values.zone_ids.length > 0) && <div>
                                                {<label className="text-slate-500">Zones : </label>}
                                                {formik.values.zone_ids.map((item, i) => {
                                                    return <p key={i}>{item.zone_name}</p>
                                                }
                                                )}
                                            </div>}
                                            {!formik.values.zone_ids?.length ? <>
                                            {(Array.isArray(actual_target.state_ids) && actual_target.state_ids.length > 0) && (<div>
                                                <label className="text-slate-500">States : </label>
                                                {formik.values.state_ids.map((item, i) => {
                                                    if (actual_target.state_ids.includes(item.state_id))
                                                        return <p>{item.state_name}</p>
                                                }
                                                )}
                                            </div>)}
                                            {(Array.isArray(actual_target.district_ids) && actual_target.district_ids.length > 0) && <div>
                                                {<label className="text-slate-500">Districts : </label>}
                                                {formik.values.district_ids.map((item, i) => {
                                                    if (actual_target.district_ids.includes(item.dist_id))
                                                        return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.ex_districts) && actual_target.ex_districts.length > 0) && <div>
                                                {<label className="text-slate-500">Excluded Districts : </label>}
                                                {formik.values.district_ids.map((item, i) => {
                                                    if (actual_target.ex_districts.includes(item.dist_id))
                                                        return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(formik.values.constituency_ids) && formik.values.constituency_ids.length > 0) && <div>
                                                {formik.values.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                                {formik.values.constituency_ids.map((item, i) => {
                                                        return <p key={i}>{`${item.const_name}(C), ${item.district_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.mandal_ids) && actual_target.mandal_ids.length > 0) && <div>
                                                {<label className="text-slate-500">Mandals : </label>}
                                                {formik.values.mandal_ids.map((item, i) => {
                                                    if (actual_target.mandal_ids.includes(item.mandal_id))
                                                        return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.ex_mandals) && actual_target.ex_mandals.length > 0) && <div>
                                                {<label className="text-slate-500">Excluded Mandals : </label>}
                                                {formik.values.mandal_ids.map((item, i) => {
                                                    if (actual_target.ex_mandals.includes(item.mandal_id))
                                                        return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.village_ids) && actual_target.village_ids.length > 0) && <div>
                                                {<label className="text-slate-500">villages : </label>}
                                                {formik.values.village_ids.map((item, i) => {
                                                    if (actual_target.village_ids.includes(item.village_id))
                                                        return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.ex_villages) && actual_target.ex_villages.length > 0) && <div>
                                                {<label className="text-slate-500">Excluded villages : </label>}
                                                {formik.values.village_ids.map((item, i) => {
                                                    if (actual_target.ex_villages.includes(item.village_id))
                                                        return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            </> : null}
                                            {(Array.isArray(formik.values.app) && formik.values.app.length > 0) && <div>
                                                {<label className="text-slate-500">App Category : </label>}
                                                {formik.values.app.map((item, i) => (

                                                    <p key={i}> {appCategoryOptions_preview[item]}</p>
                                                )
                                                )}
                                            </div>}
                                            {(Array.isArray(formik.values.minspend) && formik.values.minspend.length > 0) && <div>
                                                {<label className="text-slate-500">Minimum Spend : </label>}
                                                {formik.values.minspend.map((item, i) => (

                                                    <p key={i}>{item}</p>
                                                )
                                                )}
                                            </div>}
                                            {formik.values ? <div>
                                                {formik.values.min_age > 0 && <p><label className="text-slate-500">Min Age</label> : {formik.values.min_age}</p>}
                                                {formik.values.max_age > 0 && <p><label className="text-slate-500">Max Age</label> : {formik.values.max_age}</p>}
                                                {formik.values.os !== '' && <p><label className="text-slate-500">OS</label> : {osOptions_preview[formik.values.os]}</p>}
                                                {formik.values?.android_version !== '' ? <p><label className="text-slate-500">Android Version</label> : {formik.values?.android_version}</p> : null}
                                                {formik.values?.ios_version !== '' ? <p><label className="text-slate-500">IOS Version</label> : {formik.values?.ios_version}</p> : null}
                                                {genderOptions_preivew[formik.values.gender] !== null && <p><label className="text-slate-500">Gender</label> : {genderOptions_preivew[formik.values.gender]} </p>}
                                            </div> : null}
                                        </section>
                                    </>
                                    }

                                    {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                                        <h6 className="mb-2">Budget</h6>
                                        {location.state?.start?.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">CPC Price : </label>
                                            {location.state?.start?.campaign_type === "CPC" && location.state?.date_budget_preview?.cpc_price > 0 ? <b>{location.state?.date_budget_preview?.cpc_price}</b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type === "CPD" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">CPD Price : </label>
                                            {location.state?.start?.campaign_type === "CPD" && location.state?.creatselect?.cpd > 0 ? <b>{location.state?.creatselect?.cpd}</b> : <>-</>}
                                        </div>}

                                        {location.state?.start?.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">CPM Price : </label>
                                            {location.state?.start?.campaign_type === "CPM" && location.state?.date_budget_preview?.cpm > 0 ? < b>{location.state?.date_budget_preview?.cpm}</ b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type !== "CPD" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Daily Budget : </label>
                                            {location.state?.date_budget_preview?.daily_budget > 0 ? < b>{location.state?.date_budget_preview?.daily_budget}</ b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type !== "CPD" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Total Budget : </label>
                                            {location.state?.date_budget_preview?.total_budget > 0 ? < b>{location.state?.date_budget_preview?.total_budget}</ b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Daily Click Cap : </label>
                                            {location.state?.start?.campaign_type === "CPC" && location.state?.date_budget_preview?.daily_click_cap > 0 ? < b>{location.state?.date_budget_preview?.daily_click_cap}</ b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Daily Impression Cap : </label>
                                            {location.state?.start?.campaign_type === "CPM" && location.state?.date_budget_preview?.daily_imp_cap > 0 ? < b>{location.state?.date_budget_preview?.daily_imp_cap}</ b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Total Click Cap : </label>
                                            {location.state?.start?.campaign_type === "CPC" && location.state?.date_budget_preview?.tot_click_cap > 0 ? < b>{location.state?.date_budget_preview?.tot_click_cap}</ b> : < b>{" "} -</ b>}
                                        </div>}

                                        {location.state?.start?.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                                            <label className="text-slate-500">Total Impression Cap : </label>
                                            {location.state?.start?.campaign_type === "CPM" && location.state?.date_budget_preview?.tot_imp_cap > 0 ? < b>{location.state?.date_budget_preview?.tot_imp_cap}</ b> : < b>{" "} -</ b>}
                                        </div>}
                                    </section>}
                                    {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                                        <h6 className="mb-2">Date</h6>
                                        {!isBrandAd ? 
                                        <>{<div className="flex justify-between mb-2">
                                        <label className="text-slate-500">Start Date :</label>
                                        {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.start) || (location.state?.start?.campaign_type !== "CPD" && location.state?.date_budget_preview?.start_date)) ?
                                            < b>{location.state?.start?.campaign_type === 'CPD' ? DatetoTimestamp(location.state?.date_budget_preview?.start) : DatetoTimestamp(location.state?.date_budget_preview?.start_date)}</ b> : < b>{" "} -</ b>}
                                        </div>}
                                        {<div className="flex justify-between mb-2">
                                        <label className="text-slate-500">End Date :</label>
                                        {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.start) || (location.state?.start?.campaign_type !== "CPD" && location.state?.date_budget_preview?.end_date)) ? < b>{location.state?.start?.campaign_type !== 'CPD' ? DatetoTimestamp(location.state?.date_budget_preview?.end_date) : End_date_cpd(location.state?.date_budget_preview?.start)}</ b> : < b>{" "} -</ b>}
                                        </div>}</> : <>
                                        {<div className="flex justify-between mb-2">
                                        <label className="text-slate-500">Start Date :</label>
                                        {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.start_date)) ?
                                            < b>{DatetoTimestamp(location.state?.date_budget_preview?.start_date)}</ b> : < b>{" "} -</ b>}
                                        </div>}
                                        {<div className="flex justify-between mb-2">
                                        <label className="text-slate-500">End Date :</label>
                                        {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.end_date)) ?
                                        < b>{DatetoTimestamp(location.state?.date_budget_preview?.end_date)}</ b> : < b>{" "} -</ b>}
                                        </div>}
                                        </>
                                        }
                                        {location.state?.start?.campaign_type !== 'CPD' && location.state?.date_budget_preview?.datelist?.length !== 0 ? <div className="flex justify-between mb-2" style={{"display": "block"}}>
                                            <label className="text-slate-500">Day Time Slots :</label>
                                            {location.state?.date_budget_preview?.datelist?.length !== 0 ? <>{(location.state?.date_budget_preview?.datelist?.length > 0 ? location.state?.date_budget_preview?.datelist.map((item, i) => (<p key={i}> {DatetoTimestamp(item.sdate)} {<br />}  {DatetoTimestamp(item.edate)}</p>)) : null)}</> : <div>None</div>
                                            }
                                            { }</div> : null}
                                        {location.state?.date_budget_preview?.till_date && <p> Till End Date</p>}

                                    </section>}
                                    {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                                        <h6>Create Select</h6>
                                        {location.state?.creatselect_preview?.ad_code !== '' && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500">Ad Code :</label> {location.state?.creatselect_preview?.ad_code}</div>}
                                        {location.state?.creatselect_preview?.line_item_code !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500">Line Item Code :</label> {location.state?.creatselect_preview?.line_item_code}</div>}
                                        {location.state?.creatselect_preview?.dfp_creative_ids && type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP Creative Ids :</label> {location.state?.creatselect_preview?.dfp_creative_ids?.split(',')?.map(item => <>{item}<br /></>)}</div> : null}
                                        {location.state?.creatselect_preview?.post_type !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Post Type :</label> {location.state?.creatselect_preview?.post_type}</div>}
                                        {location.state?.creatselect_preview?.news_type !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> News Type :</label> {location.state?.creatselect_preview?.news_type}</div>}
                                        {location.state?.creatselect_preview?.dfp_backfill_ad_type && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Dfp Backfill Ad Type :</label> {location.state?.creatselect_preview?.dfp_backfill_ad_type}</div>}
                                        {location.state?.creatselect_preview?.slotuuid && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Slot Id :</label> {location.state?.creatselect_preview?.slotuuid}</div>}
                                        {location.state?.creatselect_preview?.banner_size?.length && location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500"> Banner Size :</label> {location.state?.creatselect_preview?.banner_size?.join(',')}</div> : null}

                                        {<div className="flex justify-between mb-2"><label className="text-slate-500">Creative Type  :</label> {location.state?.creatselect_preview?.creative_type !== '' ? location.state?.creatselect_preview?.creative_type : "-"}</div>}
                                        {location.state?.creatselect_preview?.frequency_cap > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency :</label>  {location.state?.creatselect_preview?.frequency_cap}</div>}
                                        {location.state?.creatselect_preview?.frequency_cap_type !== '' && location.state?.creatselect_preview?.positiontype === "rotation" && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency Cap Type :</label>  {location.state?.creatselect_preview?.frequency_cap_type}</div>}
                                        <div className="flex justify-between mb-2"><label className="text-slate-500">Position : </label>{location.state?.creatselect_preview?.position}</div>
                                        {location.state?.creatselect_preview?.positiontype !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Position Type :</label> {location.state?.creatselect_preview?.positiontype}</div>}
                                        {location.state?.creatselect_preview?.positiontype === 'rotation' && location.state?.creatselect_preview?.action_type !== null && <div className="flex justify-between mb-2"><label className="text-slate-500">Action type :</label> {location.state?.creatselect_preview?.action_type}</div>}
                                        {localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson ? <div className="flex justify-between mb-2"><label className="text-slate-500">Priority :</label> {+location.state?.creatselect_preview?.priority ? +location.state?.creatselect_preview?.priority : < b>{" "} -</ b>}</div> : null}
                                        {location.state?.type !== "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">Encryption  :</label> {location.state?.creatselect_preview?.encryption ? 'True' : 'False'}</div> : null}
                                        {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">Hidden  :</label> {location.state?.creatselect_preview?.dfp_hidden ? 'True' : 'False'}</div> : null}
                                        {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP IMA  :</label> {location.state?.creatselect_preview?.dfp_ima ? 'True' : 'False'}</div> : null}
                                        {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP PGDEAL  :</label> {location.state?.creatselect_preview?.dfp_pgdeal ? 'True' : 'False'}</div> : null}
                                        {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP IMA Obstacle :</label> {location.state?.creatselect_preview?.dfp_ima_obs ? 'True' : 'False'}</div> : null}
                                    </section>}
                                    
                                    {location.state.discount_obj ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                    <h6>Discount</h6>
                                    {location.state.discount_obj.discount_no ? <div className="flex justify-between mb-2"><label className="text-slate-500">Discount :</label> {`${location.state.discount_obj.discsign ? "+" : "-"} ${location.state.discount_obj.discount_no} %`}</div> : null}
                                    {location.state.discount_obj.actualPrice ? <div className="flex justify-between mb-2"><label className="text-slate-500">Actual Price  :</label> {location.state.discount_obj.actualPrice}</div> : null}
                                    {location.state.discount_obj.discountPrice ? <div className="flex justify-between mb-2"><label className="text-slate-500">After Discount  :</label> {location.state.discount_obj.discountPrice}</div> : null}
                                    </section> : null}
                                </>
                            }

                        </div>
                        {<section className="basis-5/12 rounded-2xl overflow-hidden">
                            {<> {(location.state?.creatselect_preview?.creatives_preview?.length > 0 ?
                                <Swiper
                                    spaceBetween={0}
                                    pagination={true}
                                    navigation={true}
                                    modules={[Navigation, Pagination]}
                                    className="mySwiper"
                                    style={{ width: "460px" }}>
                                    {location.state?.creatselect_preview?.creatives_preview?.map((campPreview) => <SwiperSlide><campCreativeContext2.Provider value={{ campPreview }}><PreviewFrameEdit showPreview={true} /></campCreativeContext2.Provider></SwiperSlide>)}</Swiper> : <>
                                    <section className="preview-mobile">
                                        <div className="preview-inner">
                                            <div className="preview-full-image">
                                                <div className='mt-60 ml-1 preview-text'>Preview of your creative will be shown here once after you select your creative</div>
                                            </div>
                                        </div></section>
                                </>)} </>}
                        </section>}
                    </section>

                </div>
                <div>
                    <form onSubmit={formik.handleSubmit} className='contents'>
                        {/* <span className="ml-auto">step:2/4</span> */}
                        <Stepper
                            steps={steps}
                            activeStep={1} />

                        <div >
                            <legend className="">Targets</legend>

                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Language</label>
                                <span className="text-red-600">*</span>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="lang_ids"
                                    placeholder='select language'
                                    onBlur={formik.handleBlur}
                                    value={getvalues(languageOptions, "lang_ids")}
                                    onChange={(selected) => { onchange(selected, "lang_ids"); lang_idsOnchange(selected) }}
                                    options={languageOptions}
                                    isMulti
                                    isDisabled={location?.state?.status === 2}
                                />
                                {formik.errors.lang_ids && (formik.touched.lang_ids) ? <div className="text-red-600">{formik.errors.lang_ids}</div> : null}

                            </div>

                            {location.state.type !== "DFP" ?
                                <div>
                                    {!formik.values.state_ids?.length ? <div className="mb-3">
                                        <label htmlFor="" className="form-label">Zone</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="zone_ids"
                                            placeholder='Select Zone'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(zoneOptions, "zone_ids")}
                                            onChange={(selected) => { onchange(selected, "zone_ids"); zone_idsOnchange(selected, formik.values.lang_ids) }}
                                            options={zoneOptions}
                                            isMulti
                                        />
                                    </div> : null}
                                    {!formik.values.zone_ids?.length ? <>
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">State</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="states_ids"
                                            placeholder='Select States'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(stateOptions, "state_ids")}
                                            onChange={(selected) => { onchange(selected, "state_ids"); state_idsOnchange(selected, formik.values.lang_ids); formik.setFieldValue("zone_ids", []) }}
                                            options={stateOptions}
                                            isMulti
                                        />
                                    </div>
                                    <div className='inline-flex p-2'>
                                        <button type="button" className="btn btn-primary" style={formik.values.exclude === 0 ? { backgroundColor: 'red', border: '2px solid blue' } : {}} onClick={(e) => formik.setFieldValue("exclude", 0)}> {"Include"}</button>
                                        <button type="button" className="btn btn-primary ml-2" style={formik.values.exclude === 1 ? { backgroundColor: 'red', border: '2px solid blue' } : {}} onClick={(e) => formik.setFieldValue("exclude", 1)}>{"Exclude"}</button>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">Districts</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="district_ids"
                                            placeholder='Select Districts'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(districtOptions, "district_ids")}
                                            onChange={(selected) => { onchange(selected, "district_ids"); district_idsOnchange(selected, formik.values.lang_ids) }}
                                            options={districtOptions}
                                            isMulti
                                        />
                                    </div>
                                    {formik.values.lang_ids.filter(item => item === 1 || item === 2).length ? <div className="mb-3">
                                        <label htmlFor="" className="form-label">Constituency</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="constituency_ids"
                                            placeholder='Select Constituency'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(constituencyOptions, "constituency_ids")}
                                            onChange={(selected) => { onchange(selected, "constituency_ids"); constituency_idsOnchange(selected) }}
                                            options={constituencyOptions}
                                            isMulti
                                        />
                                    </div> : null}
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">Mandals</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="mandal_ids"
                                            placeholder='Select Mandals'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(mandalOptions, "mandal_ids")}
                                            onChange={(selected) => { onchange(selected, "mandal_ids"); mandal_idsOnchange(selected, formik.values.district_ids ? formik.values.district_ids.map((item) => item.dist_id) : [], formik.values.lang_ids, formik.values.constituency_ids) }}
                                            options={mandalOptions}
                                            isMulti
                                        />
                                    </div>
                                    {formik.values.constituency_ids.length === 0 ?<div className="mb-3">
                                        <label htmlFor="" className="form-label">Villages</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="village_ids"
                                            placeholder='Select Villages'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(villageOptions, "village_ids")}
                                            onChange={(selected) => { onchange(selected, "village_ids"); }}
                                            options={villageOptions}
                                            isMulti
                                        />
                                    </div> : null}
                                    </> : null}
                                    {/*
 {formik.values.lang_ids.length ? <div className="mb-3">
 <label htmlFor="" className="form-label">Location</label>
 <AsyncSelect
 class="form-control"
 id="" placeholder="search locations ......."
 name='location'
 loadOptions={fetchdata}
 value={ selectedlocs}
 onChange={(e) => { if (e) { conflict(e) } }}
 noOptionsMessage={() => null}
 isOptionDisabled={(option) => option.isdisabled}
 isMulti
 />
 {formik.errors.location && formik.touched.location ? <div className="text-red-600">{formik.errors.location}</div> : null}

 </div> : null} */}
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">Minimum Spend</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="minspend"
                                            placeholder='select Minimum spend'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(minimumSpendOptions, "minspend")}
                                            onChange={(selected) => onchange(selected, "minspend")}
                                            options={minimumSpendOptions} isMulti />
                                        {formik.errors.minspend && (formik.touched.minspend) ? <div className="text-red-600">{formik.errors.minspend}</div> : null}

                                    </div> </div> : null}


                            <div className="mb-3">
                                <label htmlFor="" className="form-label">OS Type</label>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="os"
                                    placeholder='select os'
                                    onBlur={formik.handleBlur}
                                    value={defaultValue(osOptions, formik.values.os)}
                                    onChange={selected => {formik.setFieldValue('os', selected.value); formik.setFieldValue("android_version", ""); formik.setFieldValue("ios_version", "")}}
                                    options={osOptions} />
                                {formik.errors.os && (formik.touched.os) ? <div className="text-red-600">{formik.errors.os}</div> : null}

                            </div>

                            {formik.values.os === '0'|| formik.values.os=== '1' ? <div className="mb-3">
                                <label htmlFor="" className="form-label">Android Version</label>
                                <Select
                                    aria-label="Default select example"
                                    name="android_version"
                                    placeholder='select version'
                                    onBlur={formik.handleBlur}
                                    value={defaultValue(w2n_android_versions, formik.values.android_version)}
                                    onChange={selected => formik.setFieldValue('android_version', selected.value)}
                                    options={w2n_android_versions} />
                                {formik.errors.android_version && (formik.touched.android_version) ? <div className="text-red-600">{formik.errors.android_version}</div> : null}

                            </div> : null}

                            {formik.values.os === '0'|| formik.values.os=== '2' ? <div className="mb-3">
                                <label htmlFor="" className="form-label">IOS Version</label>
                                <Select
                                    aria-label="Default select example"
                                    name="ios_version"
                                    placeholder='select version'
                                    onBlur={formik.handleBlur}
                                    value={defaultValue(w2n_ios_versions, formik.values.ios_version)}
                                    onChange={selected => formik.setFieldValue('ios_version', selected.value)}
                                    options={w2n_ios_versions} />
                                {formik.errors.ios_version && (formik.touched.ios_version) ? <div className="text-red-600">{formik.errors.ios_version}</div> : null}
                            </div> : null}

                            <div className="mb-3">
                                <label htmlFor="" className="form-label">App Category</label>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="app"
                                    placeholder='select App Category'
                                    onBlur={formik.handleBlur}
                                    value={getvalues(appCategoryOptions, "app")}
                                    onChange={(selected) => apponchange([selected])}
                                    options={appCategoryOptions}
                                // isOptionDisabled={(option) => option.isdisabled}
                                // isMulti 
                                />
                                {formik.errors.app && (formik.touched.app) ? <div className="text-red-600">{formik.errors.app}</div> : null}

                            </div>


                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Gender</label>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="os"
                                    placeholder='select os'
                                    onBlur={formik.handleBlur}
                                    value={defaultValue(genderOptions, formik.values.gender)}
                                    onChange={selected => formik.setFieldValue('gender', selected.value)}
                                    options={genderOptions} />
                                {formik.errors.gender && formik.touched.gender ? <div className="text-red-600">{formik.errors.gender}</div> : null}

                            </div>
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Minimum age</label>
                                <input
                                    type="number"
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="min_age"
                                    placeholder='Minimum age'
                                    onBlur={formik.handleBlur}
                                    value={formik.values.min_age}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.min_age && (formik.touched.min_age) ? <div className="text-red-600">{formik.errors.min_age}</div> : null}

                            </div>
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Maximum age</label>
                                <input
                                    type="number"
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="max_age"
                                    placeholder='Minimum age'
                                    onBlur={formik.handleBlur}
                                    value={formik.values.max_age}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.max_age && (formik.touched.max_age) ? <div className="text-red-600">{formik.errors.max_age}</div> : null}

                            </div>
                            <div className='d-flex justify-between'>
                            <SlButton variant="neutral" onClick={back}  disabled={disableNext}>Back</SlButton>
                                <SlButton type='submit' variant="primary" disabled={disableNext} >Next</SlButton>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    )

}

export default Target
